import script from "./cao919Dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./cao919Dashboard.vue?vue&type=script&setup=true&lang=js"

import "./cao919Dashboard.vue?vue&type=style&index=0&id=4c1c456e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c1c456e"]])

export default __exports__